export default {"src":"https://images-cdn.curipod.com/d-92f5a510/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};